import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import GettingStartedImageAndContent from 'src/app/organisms/Homepage/GettingStartedImageAndContent/GettingStartedImageAndContent';

const GettingStarted = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    maxWidth='width-3xl'
    data-track-section='getting-started'
  >
    <GettingStartedImageAndContent />
  </SectionLayout>
);

export default GettingStarted;
